module.exports = __webpack_public_path__ + "img/17-about.5e9573f7.jpg";